export default __webpack_public_path__ + "static/LogoWEB Horizontal Amarillo Transparente-d97eb16a017e6057422ce85b738d8d1a.svg";